import { makeStyles } from '@material-ui/core'
export const styleOverride = makeStyles({
  root: {
    textAlign: 'center',
  },
})

export const customStyles = makeStyles({
  closeButton: {
    cursor: 'pointer',
    float: 'right',
    width: '20px !important',
  },
})